module.exports = __webpack_public_path__ + "img/s1v3.6667b41e.jpeg";